/* eslint-disable react/no-danger */
import PropTypes from 'prop-types';
import styles from './ExemplarResponse.scss';

const addSuperscripts = (html) => {
  const $html = global.$(html);
  $html.find('span[data-serial]').each((index, span) => {
    const $span = global.$(span);
    const $sup = global.$('<sup />').text($span.attr('data-serial'));
    $span.append($sup);
  });

  const el = $html.get(0);
  return el ? el.outerHTML : html;
};

const ExemplarResponse = ({ body, highlightedItemSerial }) => (
  <div>
    <h3 className={styles.exemplarResponseHeading}>Exemplar Response</h3>
    <div
      className={styles.exemplarResponse}
      dangerouslySetInnerHTML={{ __html: addSuperscripts(body) }}
      data-highlighted-item={highlightedItemSerial || null}
    />
  </div>
);

ExemplarResponse.propTypes = {
  // body is the html exemplar response.
  body: PropTypes.string,
  highlightedItemSerial: PropTypes.number,
};

export default ExemplarResponse;
